import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getLocationSuccess,
  getLocationDenied,
} from '../redux/actions/Common.action';
import fallBackImage from '../assets/fallBack.png';
import { getItemFromLocalStorage } from '../utils';

const withLocation = ({
  component,
  getLocationSuccess,
  locFound,
  history,
  bookingSuccess,
}) => {
  // window.ReactNativeWebView.postMessage('askForLocation');
  document.addEventListener('message', function (data) {
    if (typeof data.data === 'string') {
      const messageFromNative = JSON.parse(data.data);
      if (messageFromNative.backHandler) {
        if (
          window.location.pathname.indexOf('salon-checkout') > -1 &&
          bookingSuccess
        ) {
          window.location.href = '/';
        }
        if (window.location.pathname.indexOf('view-service') > -1) {
          window.location.href = '/';
        } else {
          history.goBack();
        }
        return false;
      }
      if (messageFromNative.longitude && messageFromNative.latitude) {
        getLocationSuccess();
        localStorage.setItem(
          'location',
          JSON.stringify({
            latitude: messageFromNative.latitude,
            longitude: messageFromNative.longitude,
          }),
        );
      }
      if (messageFromNative.fcmToken) {
        localStorage.setItem('fcmToken', messageFromNative.fcmToken);
      }
      if (messageFromNative.deviceType) {
        localStorage.setItem('deviceType', messageFromNative.deviceType);
      }
    }
  });
  window.addEventListener('message', function (data) {
    if (typeof data.data === 'string' && data.data) {
      const messageFromNative = JSON.parse(data.data);
      if (messageFromNative.backHandler) {
        history.goBack();
        return false;
      }
      if (messageFromNative.longitude && messageFromNative.latitude) {
        getLocationSuccess();
        localStorage.setItem(
          'location',
          JSON.stringify({
            latitude: messageFromNative.latitude,
            longitude: messageFromNative.longitude,
          }),
        );
      }
      if (messageFromNative.fcmToken) {
        localStorage.setItem('fcmToken', messageFromNative.fcmToken);
      }
      if (messageFromNative.deviceType) {
        if(messageFromNative.deviceType === 'ios') {
          getLocationSuccess();
        }
        localStorage.setItem('deviceType', messageFromNative.deviceType);
      }
    }
  });
  if (locFound === 'fetched' || getItemFromLocalStorage('location') ||  localStorage.getItem('deviceType')) {
    return component;
  } else {
    return (
      <img style={{ width: '100%', height: '100%' }} src={fallBackImage} />
    );
  }
};

const mapStateToProps = ({ CommonReducer }) => ({
  locFound: CommonReducer.locFound,
  bookingSuccess: CommonReducer.bookingSuccess,
});

const mapDispatchToProps = {
  getLocationSuccess: getLocationSuccess,
  getLocationDenied: getLocationDenied,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withLocation),
);
